import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import CircularWithValueLabel from '../../components/circular-progress';
import ImageSlide from '../../components/slide/ImageSlide';
import VideoSlide from '../../components/slide/VideoSlide';
import EagleTracker from '../../components/eagle-tracker';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const Hospitality17Page = (props) => {
  const { eagleCount, prevEagleCount } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const [isEagleTrackerLoading, setIsEagleTrackerLoading] = useState(true);
  const [isFirstSlideLoading, setIsFirstSlideLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!isEagleTrackerLoading && !isFirstSlideLoading) {
      const timeoutId = setTimeout(() => {
        setIsLoading(false);
      }, 500);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isEagleTrackerLoading, isFirstSlideLoading]);

  useEffect(() => {
    if (isLoading) return;

    console.log(`Showing slide ${index} for ${slideIntervals()[index]/1000} seconds.`);
    const timeoutId = setTimeout(() => {
      setIndex((index) => {
        let nextIndex = 0;
        const nextZeroBasedIndex = Object.keys(slideIntervals()).indexOf(index.toString()) + 1;
        if (nextZeroBasedIndex < Object.keys(slideIntervals()).length) {
          nextIndex = parseInt(Object.keys(slideIntervals())[nextZeroBasedIndex]);
        }
        console.log(`Active slide: ${nextIndex}`);
        return nextIndex;
      });
    }, slideIntervals()[index]);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [index, isLoading]);

  const slideIntervals = () => {
    const defaultIntervals = {
      0: 500,
      1: 30000,   // Video: Grit to Vision
      2: 500,
      3: 30000,   // Image: JR Fooch Partnership
      4: 500,
      5: 30000,   // Image: Good Luck Justin Rose
      6: 500,
      7: 30000,   // Video: Behind the Drive
      8: 500,
      9: 30000,   // Image: First Tee Messaging
      10: 500,
      11: 32500,  // Eagle Tracker
      12: 500,
      13: 30000,  // Image: Fan Tent CTA
      14: 500,
      15: 30000   // Image: Morgan Stanley Institute
    };

    const tuesday = {
      16: 500,
      17: 30000
    };

    const wednesday = {};

    const thursday = {
      18: 500,
      19: 30000,
      20: 500,
      21: 30000
    };

    const friday = {
      22: 500,
      23: 30000,
      24: 500,
      25: 30000,
      26: 500,
      27: 30000,
    };

    const saturday = {
      28: 500,
      29: 30000,
    };

    const sunday = {};

    const selectedDay = searchParams.get("day");
    const dayOfWeek = selectedDay ? parseInt(selectedDay) : (new Date()).getDay();
    console.log(`Using lineup for week day ${dayOfWeek}`);
    var allIntervals = {};

    switch (dayOfWeek) {
      case 2: allIntervals = { ...defaultIntervals, ...tuesday };
        break;
      case 3: allIntervals = { ...defaultIntervals, ...wednesday };
        break;
      case 4: allIntervals = { ...defaultIntervals, ...thursday };
        break;
      case 5: allIntervals = { ...defaultIntervals, ...friday };
        break;
      case 6: allIntervals = { ...defaultIntervals, ...saturday };
        break;
      case 7: allIntervals = { ...defaultIntervals, ...sunday };
        break;
      default: allIntervals = defaultIntervals;
    }

    return allIntervals;
  };

  const customRenderItem = (item, props) => (
    <item.type {...item.props} {...props} />
  );

  return (
    <div className="App">
      {isLoading ? <CircularWithValueLabel /> : null}
      <Carousel
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        infiniteLoop={true}
        transitionTime={5}
        stopOnHover={false}
        swipeable={false}
        useKeyboardArrows={false}
        showIndicators={false}
        autoPlay={false}
        renderItem={customRenderItem}
        selectedItem={index}
      >
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <VideoSlide
          playing={index === 1}
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/grit_to_vision_h.mp4"
          setIsLoading={setIsFirstSlideLoading}
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/jr_fooch_partnership_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/good_luck_justin_rose_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <VideoSlide
          playing={index === 7}
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/behind_the_drive_h.mp4"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/first_tee_messaging_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <EagleTracker 
          eagleCount={eagleCount} 
          prevEagleCount={prevEagleCount} 
          canPlay={index === 11}
          takeoverMode={false}
          setIsLoading={setIsEagleTrackerLoading}
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/fan_tent_cta_h.png"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/ms_institute_h.png"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/17_appearance_tuesday_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/appearance_thursday_new_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/highlights_thursday_new_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/appearance_1_friday_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/appearance_2_friday_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/highlights_friday_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/highlights_saturday_h.jpg"
          orientation="landscape"
        />
      </Carousel>
    </div>
  );
};

export default Hospitality17Page;
